import { Field } from './field';
import { TenantGeneralData } from './tenantGeneralData';
export class FieldGroup extends TenantGeneralData {
  id: number;
  name: string;
  lotId: string;
  fields: Array<Field>;
  colorR?: number;
  colorG?: number;
  colorB?: number;

  constructor() {
    super();
    this.id = null;
    this.name = null;
    this.lotId = null;
    this.fields = null;
    this.colorR = null;
    this.colorG = null;
    this.colorB = null;
  }
}

/*
*********** MODELLO DI BACKEND **********************

package com.xfarm.api.v1.core

import com.xfarm.api.v1.auth.User

class FieldGroup {

    transient springSecurityService

    Long    companyId = -1
    string  name
    string  lotId

    static hasMany = [fields: Field]

    static mapping =  {
        fields  cascade: 'save-update'
    }

    def beforeInsert() {
        companyId = User.get(springSecurityService?.principal?.id)?.farm?.id
    }

    def beforeUpdate() {
        if(companyId != User.get(springSecurityService?.principal?.id)?.farm?.id){
            return false
        }
    }

    def beforeDelete() {
        Field.withNewSession {
            Field.findAllByGroup(this).each {
                it.group = null
                it.save(flush: true)
            }
        }
    }

    static transients = ['springSecurityService']

    static constraints = {
        // TODO Fix beforeInsert and beforeUpdate Events Bugs and set compoanyId nullable:false
        companyId   blank: false
        name        blank: false
        lotId       blank: false, nullable: true
    }
}

*/
